export default "__VITE_PUBLIC_ASSET__f4b5dc26__"